import {
  PractiseType,
  Scope,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ScopeChildDto, ScopeDto } from './scope.model';

export function mapScope(scopeDto: ScopeDto | ScopeChildDto): Scope {
  return {
    id: scopeDto.id,
    type: scopeDto.type,
    subject: scopeDto.subject,
    level: scopeDto.level,
    year: scopeDto.year,
  };
}

export function getParagraphIdsFromScopesDto(scopesDto: ScopeDto[]): string[] {
  return scopesDto.reduce((paragraphIds: string[], scope) => {
    if (scope.personUsesBook) {
      paragraphIds.push(scope.personUsesBook.lastUsedParagraphId);
    }
    return paragraphIds;
  }, []);
}

export function getPractiseTypesFromScopes(
  scopes: Scope[] | ScopeDto[],
): PractiseType[] {
  return scopes
    .map((scope) => scope.type)
    .filter((value, index, self) => self.indexOf(value) === index);
}
